// src/graphql/seoQueries.js
import { gql } from '@apollo/client';

export const GET_SEO_ISSUES = gql`
  query GetSEOHelperIssues($shopId: ID!) {
    seoIssues(shopId: $shopId) {
      criticalCount
      warningCount
      fixableCount
      totalCount
      currentScore
      potentialScore
      metaTags {
        id
        pageUrl
        currentTitle
        currentDescription
        suggestedTitle
        suggestedDescription
        status
      }
      altText {
        id
        imageUrl
        product
        currentAlt
        suggestedAlt
        status
      }
      brokenLinks {
        id
        url
        sourcePage
        status
        suggestedFix
      }
      content {
        id
        pageUrl
        issue
        suggestion
        status
      }
    }
  }
`;

export const APPLY_FIX = gql`
  mutation ApplySEOFix($input: ApplyFixInput!) {
    applyFix(input: $input) {
      success
      message
      previousState
    }
  }
`;

export const REGENERATE_SUGGESTION = gql`
  mutation RegenerateSuggestion($input: RegenerateSuggestionInput!) {
    regenerateSuggestion(input: $input) {
      success
      message
      newSuggestion
    }
  }
`;

export const BULK_APPLY_FIXES = gql`
  mutation BulkApplyFixes($input: BulkApplyFixesInput!) {
    bulkApplyFixes(input: $input) {
      success
      message
      count
      previousStates
    }
  }
`;